
import {mapGetters} from 'vuex'
import codeCountdownMixins from "./code-countdown";
import countryMixins from "./country-mixins";
import UrlConfig from '@/api/base-url.js';
// import { getDeviceFingerprint } from "@/mixins/fingerprint.js"
import axios from 'axios';
export default {
  mixins: [codeCountdownMixins,countryMixins],
  props: {
    title: String,

  },
  data() {
    var _this = this;
    var validatePass = (rule, value, callback) => {
      let nameReg = new RegExp(/(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{5,16}/); //只允许5-16位数字与字母组合
      let passReg = new RegExp(/(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}/); //只允许6-20位数字与字母组合
      let PayReg = new RegExp(/^\d{6}$/); //只允许输入6位数数字
      let emailReg = new RegExp(
        /^[A-Za-z\d]+([-_\.][A-Za-z\d]+)*@([A-Za-z\d]+[-\.])+[A-Za-z\d]{2,4}(,[A-Za-z\d]+([-_\.][A-Za-z\d]+)*@([A-Za-z\d]+[-\.])+[A-Za-z\d]{2,4})*$/
      );

      let ruleForm = _this.ruleForm;
      let config = this.config;
      let text = "";
      if (value === "") {
        if (rule.field === "UserName") {
          text = "請輸入用戶名";
        }
        if (rule.field === "Mobile") {
          text = "請輸入手機號";
        }
        if (rule.field === "Password") {
          text = "請輸入密碼";
        }
        if (rule.field === "Password2") {
          text = "請再次輸入密碼";
        }
        if (rule.field === "VerCode") {
          text = "請輸入驗證碼";
        }
        if (rule.field === "PayPassword") {
          text = "請輸入6位數字資金密碼";
        }
        if (rule.field === "Email") {
          text = "請輸入郵箱";
        }
        if (
          rule.field === "InviteCode" &&
          this.siteInfo &&
          !this.siteInfo.InviteCode &&
          !this.siteInfo.Setting.InviteCode
        ) {
          text = "請輸入邀請碼";
        }
        if (rule.field === "ImgCode") {
          text = "請輸入圖形碼";
        }
        if (rule.field === "Currency") {
          text = "請選擇幣種";
        }
        callback(new Error(text));
      }
      if (value) {
        if (rule.field === "UserName" && !nameReg.test(value)) {
          text = "帳號必須5-16位數字與字母組合";
          callback(new Error(text));
        }

        if (rule.field === "Password" && !passReg.test(value)) {
          text = "請輸入6-20位密碼，必須包括數位和字母";
          callback(new Error(text));
        }
        if (
          rule.field === "Password2" &&
          ruleForm.Password != ruleForm.Password2
        ) {
          text = "兩次輸入的密碼不一致";
          callback(new Error(text));
        }
        if (rule.field === "VerCode" && value.length < 4) {
          text = "請輸入正確驗證碼";
          callback(new Error(text));
        }

        if (rule.field === "PayPassword" && !PayReg.test(value)) {
          text = "資金密碼必須為6位數字";
          callback(new Error(text));
        }

        if (rule.field === "Email" && !emailReg.test(value)) {
          text = "請檢查郵箱格式";
          callback(new Error(text));
        }
        if (rule.field === "ImgCode" && config.IsMobile) {
          if (value.toString().length != 4) {
            text = "請輸入正確圖形碼";
            callback(new Error(text));
          }
        }
      }
      callback();
    };
    return {
      loginType: "Name", //'Name',//Mobile
      remember: false,
      verTypeActive: "Mobile",
      verTypeTabs: [],
      ruleForm: {
        UserName: "",
        Password: "",
        Password2: "",
        PayPassword: "",
        RealName: "",
        Mobile: "",
        Area: "",
        VerCode: "",
        InviteCode: "",
        Email: "",
        ImgCode: "",
        Currency: "",
      },
      rules: {
        Password: [{ validator: validatePass, trigger: "blur" }],
        Password2: [{ validator: validatePass, trigger: "blur" }],
        UserName: [{ validator: validatePass, trigger: "blur" }],
        Mobile: [{ validator: validatePass, trigger: "blur" }],
        VerCode: [{ validator: validatePass, trigger: "blur" }],
        RealName: [{ validator: validatePass, trigger: "blur" }],
        Email: [{ validator: validatePass, trigger: "blur" }],
        PayPassword: [{ validator: validatePass, trigger: "blur" }],
        ImgCode: [{ validator: validatePass, trigger: "blur" }],
        Currency: [{ validator: validatePass, trigger: "blur" }],
      },
      isPage: false,
      config: {},
      loading: false,
      codeImgSrc: "",
      timer: null,
      DropdownWidth: 300,
      IsInviteCurrency: false,
      InviteCodeLen: 8, //邀请码长度
      waitSiteTimer: null,
      Is1012: false,
      parentType:"",
      showInviteCode:false,
      checkError:false,
      isCHN:false,
      DeviceId: null, //设备ID

    }
  },

  computed: {
    ...mapGetters(["get_siteInfo",'get_currencyList','get_ShowCaptcha','get_CaptchaVerifiedID']),
    siteInfo(){
      return this.get_siteInfo;
    },
    sendText(){
      if( typeof this.sendCodeText === "number"){
        return this.sendCodeText;
      } else{
        return "發送驗證碼"
      }
    },
    IsSingleWallet(){
      let siteInfo=this.siteInfo;
      if(siteInfo&&siteInfo.Wallet==='1'){
        return true;
      } else{
        return false;
      }
    },
    InvitePlaceholder() {
      let text = "";
      if (this.siteInfo && this.siteInfo.InviteCode) {
        text = "請輸入邀請碼(選填)";
      } else {
        if (
          this.siteInfo &&
          !this.siteInfo.InviteCode &&
          this.siteInfo.Setting&&
          !this.siteInfo.Setting.InviteCode
        ) {
          text = "請輸入邀請碼(必填)";
        } else {
          text = "請輸入邀請碼(選填)";
        }
      }

      return text;
    },
    hasInviteCode(){
      let ruleForm = this.ruleForm;
      let InviteCodeLen = this.InviteCodeLen;
      if(ruleForm.InviteCode&&ruleForm.InviteCode.length==InviteCodeLen){
        return true
      } else{
         return false
      }
    },
    currencyListView() {
      let currencyList = this.get_currencyList;
      return currencyList;
    },
    USDTMobileVerification(){
      let Setting=this.siteInfo.Setting;
      if(this.IsSingleWallet){
        if(this.ruleForm.Currency=='USDT'&&Setting.USDTVerification=="0"){
          return false;
        }else{
          return true;
        }
      }else{
        return true;
      }
    },

  },
  watch: {

  },
  created() {
    if (this.siteInfo && this.siteInfo.ID) {
      this.initConfig();
    } else {
      this.timerInit();
    }

  },
  mounted() {
    //获取设备指纹ID
    this.getDevice();
    this.getImgSrc();
    this.$nextTick(() => {
      this.countryArea();
      // let query = this.$route.query;
      // let params = this.$route.params;
      let query = this.getQueryObj();
      let params = this.getQueryObj();
      let InviteCode = query.InviteCode || query.inviteCode ||  query.Invitecode || query.invitecode || params.id;
      InviteCode = InviteCode? InviteCode : sessionStorage.getItem("InviteCode");
      this.waitSiteTimer = setInterval(() => {
        let siteInfo = this.siteInfo;
        if (siteInfo && siteInfo.ID) {
          clearInterval(this.waitSiteTimer);
          if (InviteCode) {
            this.ruleForm.InviteCode = InviteCode;
          } else {
            if (siteInfo.InviteCode) {
              this.ruleForm.InviteCode = this.siteInfo.InviteCode;
            }
          }
          if(this.ruleForm.InviteCode){
            this.getInviteCurrency("InviteCode");
          } else{
            this.showInviteCode=true;
          }
          if(query&&(query.Currency || query.currency)){
            if(query.Currency){
              this.ruleForm.Currency = this.convertToUpperCase(query.Currency);
            }
            if(query.currency){
              this.ruleForm.Currency = this.convertToUpperCase(query.currency);
            }
          }

          // this.setCurrency1012(); //针对1012，暂时只支持TWD,等上线其他币种后修改
        }
      }, 100);
    });
  },
  methods: {

    getImgSrc(){
      let smsSrc='/request/ValidateCode.png?name=sms'
      this.timeStamp = new Date().getTime();
      this.codeImgSrc = UrlConfig.baseUrl + smsSrc +'&TOKEN='+this.timeStamp;
    },
    setCountryCode(Code){
      if(Code){
        this.ruleForm.Area=Code;
      } else{
        this.ruleForm.Area="";
      }
    },
    setAreaCode(item){
      this.ruleForm.Area=item.dialCode;
    },
    setCurrency1012() {
      //针对1012，暂时只支持TWD,等上线其他币种后修改
      let siteInfo = this.siteInfo;
      if (siteInfo && siteInfo.ID == "1012") {
        this.ruleForm.Currency = "TWD";
        this.ruleForm.Area='886'
        this.Is1012 = true;
      } else{
        this.ruleForm.Currency = "";
        this.Is1012 = false;
      }
    },
    initConfig() {

      let apiUrl=UrlConfig.baseUrl+"/request/config/register";
      axios.post(apiUrl).then(response => {
        let res=response.data;
        if (res && res.success == 1) {
          let info = res.info || {};
          this.config = info;
          this.verTypeTabs = [];
          if (info.IsMobile) {
            this.verTypeTabs.push({
              Type: "Mobile",
              Name: "手機驗證",
            });
          }
          if (info.IsEmail) {
            this.verTypeTabs.push({
              Type: "Email",
              Name: "郵箱驗證",
            });
          }
          if (this.verTypeTabs.length > 0) {
            this.verTypeActive = this.verTypeTabs[0].Type;
          }
        }
      });
    },

    choseWallet(Currency) {
      if (this.IsInviteCurrency) return false;
      this.ruleForm.Currency = Currency;
      if(this.IsSingleWallet&&(Currency=='TWD' || Currency=='twd')){
        this.ruleForm.Area='886'
      }
      this.$refs["signUpForm"].validateField(["Currency"], (error) => {});
    },
    getDropdownWidth() {
      let dropdownDiv = document.getElementById("wallet-dropdown-link");
      if (dropdownDiv) {
        this.DropdownWidth = dropdownDiv.offsetWidth;
      }
    },
    clearValid(validName) {
      this.$refs["signUpForm"].clearValidate([validName]);
    },

    submitForm(btnType) {
      if(btnType){
        this.$nextTick(()=>{
          let signBox=this.$refs.signBox;
          signBox.scrollIntoView({ behavior: 'smooth' });
          // this.$refs["signUpForm"].clearValidate(); // 清除验证状态，但不重置表单项的值
        })
      }

      this.$refs["signUpForm"].validate((valid) => {
        if (valid) {
          this.toSignUp();
        } else {
          return false;
        }
      });

    },

    toSignUp() {
      let  curUrl = window.location.href;
      let aipData = {
        UserName: this.ruleForm.UserName,
        Password: this.ruleForm.Password,
        Password2: this.ruleForm.Password2,
        VerificationType: this.verTypeActive,
        DeviceId:this.DeviceId,
        RegisteredFrom:curUrl
      };
      if (this.ruleForm.RealName) {
        aipData.AccountName = this.ruleForm.RealName;
      }
      if (this.ruleForm.Email) {
        aipData.Email = this.ruleForm.Email;
      }
      if (this.ruleForm.Mobile) {
        aipData.Mobile = this.ruleForm.Mobile;
        aipData.Area = "+" + this.ruleForm.Area;
      }
      if (this.ruleForm.VerCode) {
        aipData.Code = this.ruleForm.VerCode;
      }

      if (this.ruleForm.InviteCode) {
        aipData.InviteCode = this.ruleForm.InviteCode.replace(/^\s+|\s+$/g, "");
        let PixelID = '1713757649252764';//默认
        if(aipData.InviteCode&&InviteCode_PixelID[aipData.InviteCode]){//指定代理使用指定像素ID
          PixelID = InviteCode_PixelID[aipData.InviteCode]
        }
        aipData.PixelID = PixelID
      }
      if (this.ruleForm.PayPassword) {
        aipData.PayPassword = this.ruleForm.PayPassword;
      }
      if (this.ruleForm.Currency) {
        aipData.Currency = this.ruleForm.Currency;
      }

      aipData.IsAgreement=true;
      this.loading = true;
      let apiUrl=UrlConfig.baseUrl+"/request/user/register";
      //注册开启滑块验证码开关且未有验证码ID，显示滑块验证码
      let IsCAPTCHA=this.config.IsCAPTCHA||0;
      if(!this.get_CaptchaVerifiedID&&IsCAPTCHA){
        this.$store.commit('SET_ShowCaptcha',true);
        return false;
      }

      //滑块验证码ID
      let CaptchaVerifiedID=this.get_CaptchaVerifiedID;
      aipData.id=CaptchaVerifiedID?CaptchaVerifiedID:"";
      axios.post(apiUrl,aipData,{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
        }
      }).then(response => {
        let res=response.data;
        if (res && res.success == 1) {
          this.$message({
            message: "成功註冊", //注册成功
            customClass: "messageIndex",
            type: "success",
          });

          if (res.info.Token) {
            setTimeout(() => {
              window.location.href= UrlConfig.baseUrl+"/#/zh-TW/loginSuccess?token="+res.info.Token + '&PixelID=' + aipData.PixelID
            }, 300);
          }
          this.gtagTrack("register", "成功註冊");
        } else {
          let res_msg = res.msg.replaceAll("#","");
          this.$message({
            message: res_msg,
            customClass: "messageIndex",
            type: "error",
          });
        }
      })
      .finally(() => {
        this.loading = false;
      });
    },

    gtagTrack(eventName,eventLabel){
        gtag('event', eventName, {
            event_category: 'click',
            event_label: eventLabel?eventLabel:eventName,
        });
        fbq('event', eventName);
    },

    sendCode() {
      if (this.sendDisable) {
        return false;
      }
      let validateList = ["UserName", "Password", "Password2"];
      let config = this.config;
      if (config.Name == 1) {
        validateList.push("Name");
      }
      if (config.IsEmail || config.Email) {
        validateList.push("Email");
      }
      if (config.IsMobile || config.Mobile) {
        validateList.push("Mobile");
      }
      if (config.IsMobile) {
        validateList.push("ImgCode");
      }
      let isError = false;
      this.$refs["signUpForm"].validateField(validateList, (error) => {
        if (error) {
          isError = true;
        }
      });
      if (!isError) {
        let params = {
          Code: this.ruleForm.ImgCode,
          TOKEN: this.timeStamp,
        };
        if (this.verTypeActive == "Email") {
          params.Email = this.ruleForm.Email;
          this.getRegisterEmailCode(params);
        } else {
          (params.Area = "+" + this.ruleForm.Area),
            (params.Mobile = this.ruleForm.Mobile),
            this.getRegisterCode(params);
        }
      }
    },

    timerInit() {
      this.timer = setInterval(() => {
        if (this.siteInfo && this.siteInfo.ID) {
          clearInterval(this.timer);
          this.initConfig();
        }
      }, 100);
    },
    enterInviteCode() {
      let InviteCode = this.ruleForm.InviteCode + "";
      if (InviteCode && InviteCode.length == this.InviteCodeLen) {
        this.getInviteCurrency("InviteCode");
      } else {
        if (InviteCode.length > this.InviteCodeLen) {
          this.ruleForm.InviteCode = InviteCode.substring(
            0,
            this.InviteCodeLen
          );
        } else {
          this.IsInviteCurrency = false;
        }
      }
    },
    // 全部转大写
    convertToUpperCase(text){
      let res = '';
      for (let i = 0; i < text.length; i++) {
        if (text[i] >= 'a' && text[i] <= 'z') {
          res += text[i].toUpperCase();
        } else {
          res += text[i];
        }
      }
      return res;
    },
    getQueryObj(){
      const search = window.location.search; // 获取当前URL的查询字符串
      const group = search.substring(1).split('&'); // 去除问号并拆分为数组
      const targetObject = group.reduce((obj, item) => {
        const [key, value] = item.split('=');
        obj[key] = decodeURIComponent(value); // URL解码处理
        return obj;
      }, {});
      return targetObject
    },
    getInviteCurrency(validType) {
      // let query = this.$route.query;
      let query = this.getQueryObj();
      let queryCurrency="";
      if (this.IsSingleWallet) {
        let InviteCode = this.ruleForm.InviteCode + "";
        if (InviteCode && InviteCode.length == this.InviteCodeLen) {
          let apiUrl=UrlConfig.baseUrl+"/request/user/invitecurrency";
          axios.post(apiUrl,{ InviteCode: InviteCode },
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
              }
            }
          ).then(response => {
            let res=response.data;
            if (res && res.success == 1) {
              let Currency = res.info.Currency;
              let parentType=res.info.Type;
              this.parentType=parentType;
              if (Currency&&parentType=="Member") {
                this.IsInviteCurrency = true;
                this.ruleForm.Currency = Currency;
                if (validType == "InviteCode") {
                  this.$refs["signUpForm"].validateField(
                    ["Currency", "InviteCode"],
                    (error) => {}
                  );
                } else {
                  this.$refs["signUpForm"].validateField(
                    ["InviteCode"],
                    (error) => {}
                  );
                }
              } else {
                this.IsInviteCurrency = false;
              }

              if(query&&(query.Currency || query.currency)){
                if(query.Currency){
                  queryCurrency=query.Currency;
                }
                if(query.currency){
                  queryCurrency=query.currency;
                }
                this.ruleForm.Currency = this.convertToUpperCase(queryCurrency);
              }
              if(parentType=="Agent"){
                this.showInviteCode=false;
              } else{
                this.showInviteCode=true;
              }
            } else {
              this.IsInviteCurrency = false;
              if(query&&(query.Currency || query.currency)){
                if(query.Currency){
                  queryCurrency=query.Currency;
                  console.log(queryCurrency)
                }
                if(query.currency){
                  queryCurrency=query.currency;
                }
                this.ruleForm.Currency = this.convertToUpperCase(queryCurrency);
              } else{
                this.ruleForm.Currency = "";
              }
              this.showInviteCode=true;
              this.ruleForm.InviteCode="";
              let res_msg=res.msg.replaceAll("#","");
              this.$message.error(res_msg)
            }
          })
        } else{
          this.showInviteCode=true;
          this.ruleForm.InviteCode="";
          let queryCurrency="";
          if(query&&(query.Currency || query.currency)){
            if(query.Currency){
              queryCurrency=query.Currency;
            }
            if(query.currency){
              queryCurrency=query.currency;
            }
            this.ruleForm.Currency = this.convertToUpperCase(queryCurrency);
          } else{
            this.ruleForm.Currency = "";
          }
        }
      }
    },
    //获取设备指纹ID
    // getDevice(){
    //   this.$nextTick(()=>{
    //     getDeviceFingerprint().then(result=>{
    //       this.DeviceId=result+'';
    //       console.log("DeviceId："+this.DeviceId)
    //     });
    //   })
    // }
    getDevice(){
      let DeviceId= localStorage.getItem('DeviceId') || '';
      if(DeviceId&&DeviceId!='undefined'){
        this.DeviceId=DeviceId;
      } else{
        let DeviceId = this.generateUUID();
        localStorage.setItem('DeviceId',DeviceId);
        this.DeviceId = DeviceId;
      }
    },
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
      });
    },
    // 处理验证码验证成功
    VerificationSuccess(data) {
      console.log('验证成功，data:', data)
      this.$store.commit('SET_ShowCaptcha',false);
      this.$store.commit('SET_CaptchaVerifiedID',data.id);
      this.$nextTick(()=>{
        this.toSignUp();
      })
    },
    VerificationFailed(msg) {
      console.log('验证失败:', msg)
      this.$store.commit('SET_CaptchaVerifiedID',"");
    },
    VerificationError(error) {
      console.error('加载验证码错误:', error)
    },
    VerificationClose() {
      console.log('验证码已关闭')
      this.$store.commit('SET_ShowCaptcha',false);
    }
  },

}



// WEBPACK FOOTER //
// ./src/mixins/sign-mixins.js